@use '../../scss/abstracts/variables' as *;

.extra-info-section {
  padding: 4.5rem 0 5rem;
  background-color: #efe7d7;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 10.5rem;
  position: relative;
  z-index: 1;

  @media screen and (max-width: $tablet-landscape) {
    padding: 0 6rem;
  }

  @media screen and (max-width: $tablet-portrait) {
    padding: 0 4.2rem;
  }

  @media (max-width: $phone) {
    padding: 0 1.8rem;
  }
}

.steps-row-wrapper {
  width: 100%;
  margin-bottom: 3rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 3.1rem;
    left: 12%;
    right: 12%;
    height: 1px;
    background: #ddd4c2;
    z-index: 0;
  }
}

.steps-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

.step-card {
  flex: 1;
  background: transparent;
  padding: 0 0.6rem;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  min-width: 0; // Allows shrinking below content size

  .step-badge {
    width: 6.2rem;
    height: 6.2rem;
    border-radius: 50%;
    background: #e9dcbf;
    border: 1.5px solid #bf8a2e;
    color: #5b4a23;
    font-family: 'Playfair Display', serif;
    font-size: 1.9rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2.6rem;
    transition: transform 0.4s ease;
    position: relative;
    z-index: 2;
  }

  &:hover .step-badge {
    transform: scale(1.08);
  }

  .step-header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.2rem;

    .step-title {
      font-family: 'Playfair Display', serif;
      font-size: 1.9rem;
      font-weight: 700;
      color: #2b2820;
      margin: 0;
      line-height: 1.2;
    }
  }

  .step-description {
    font-family: 'Inter', sans-serif;
    font-size: 1.4rem;
    color: #4a4636;
    line-height: 1.6;
    margin: 0;

    b {
      color: #2b2820;
    }
  }

  .step-tag {
    display: inline-block;
    align-self: center;
    margin-top: 1.8rem;
    font-family: 'Inter', sans-serif;
    font-size: 0.9rem;
    letter-spacing: 0.13em;
    text-transform: uppercase;
    font-weight: 600;
    color: #a8742a;
    border: 1px solid #bf8a2e;
    padding: 0.8rem 1.4rem;
  }
}

.main-info-content {
  text-align: center;
  width: 100%;
  max-width: 60rem;
  margin: 0 auto 3rem;
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;

  .info-eyebrow {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    font-weight: 700;
    color: #bf8a2e;
    margin-bottom: 1rem;
  }

  .info-header {
    font-family: 'Playfair Display', serif;
    font-size: 3.4rem;
    font-weight: 600;
    color: #2b2820;
    margin-bottom: 2rem;
    line-height: 1.14;

    em,
    i {
      font-style: italic;
      color: #bf8a2e;
    }
  }

  .info-description {
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-size: 1.5rem;
    color: #5b5544;
    line-height: 1.7;
    margin: 0 auto;
    max-width: 30em;
    font-weight: 400;
  }
}

.how-cta {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 4rem;
  flex-wrap: wrap;
}

.btn-outline-dark {
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  color: #2b2820;
  background: transparent;
  border: 1px solid #2b2820;
  padding: 1.4rem 2.6rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #2b2820;
    color: #f3ecdf;
  }
}

.submission-confirmation {
  margin-bottom: 2rem;
  padding: 2.5rem 2rem;
  background: #ffffff;
  border: 1px solid rgba(89, 74, 66, 0.14);
  border-radius: 30px;
  box-shadow: 0 18px 45px rgba(89, 74, 66, 0.08);
  color: #2f2f2f;
  text-align: center;
}

.submission-confirmation__greeting {
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  margin: 0 0 1rem;
  color: #593f23;
}

.submission-confirmation__text {
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  line-height: 1.85;
  color: #3f3f3f;
  text-align: center;
}

.submission-confirmation__text p {
  margin: 1rem 0;
}

.submission-confirmation__code {
  color: #2b2820;
  font-weight: 700;
}

.submission-confirmation__footer {
  margin-top: 1.75rem;
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  font-weight: 600;
  text-align: center;
  color: #533b1e;
}

.operators-loading {
  text-align: center;
  padding: 2rem;
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  color: #594a42;
}

.operators-section {
  margin-top: 3rem;
}

.operators-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2.5rem;
  justify-content: center;
  padding: 0;
}

.operator-card {
  flex: 0 1 calc(33.333% - 1.7rem);
  min-width: 280px;
  background: #ffffff;
  border: 1px solid rgba(89, 74, 66, 0.12);
  border-radius: 20px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 15px 40px rgba(89, 74, 66, 0.12);
    border-color: rgba(89, 74, 66, 0.2);
  }
}

.operator-logo {
  max-width: 100%;
  height: auto;
  max-height: 100px;
  margin-bottom: 1.5rem;
  object-fit: contain;
}

.operator-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  color: #593f23;
  margin: 0 0 1.5rem;
  line-height: 1.3;
}

.operator-contact {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.operator-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem 1rem;
  background: #f5f0eb;
  color: #594a42;
  text-decoration: none;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    background: #e8dfd7;
    color: #3f2a1f;
    border-color: rgba(89, 74, 66, 0.3);
  }
}

.operator-icon {
  font-size: 1.8rem;
  display: inline-flex;
}

@media (max-width: $tablet-portrait) {
  .operators-grid {
    flex-direction: column;
    gap: 2rem;
  }

  .operator-card {
    flex: 1 1 auto;
  }

  .extra-info-section {
    padding: 6rem 0;
  }

  .steps-row-wrapper {
    margin-bottom: 4rem;

    &::before {
      display: none;
    }
  }

  .steps-row {
    flex-direction: column;
    gap: 3rem;
    padding: 0 1rem;
  }

  .step-card {
    .step-title {
      font-size: 1.8rem;
    }

    .step-description {
      font-size: 1.3rem;
    }
  }

  .main-info-content {
    .info-header {
      font-size: 2.8rem;
    }

    .info-description {
      font-size: 1.1rem;
    }
  }
}

.safari-variant {
  background-color: #d6d1c9;
  padding: 6rem 2rem;
  margin: 4rem 8rem;
  border-radius: 30px;
  border: 1px solid rgba(179, 151, 88, 0.25);
  box-shadow: 0 15px 45px rgba(89, 74, 66, 0.08);
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    #d6d1c9 15%,
    #d6d1c9 85%,
    rgba(255, 255, 255, 1) 100%
  );

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(to bottom, #fff, transparent);
    z-index: 1;
  }

  &::after {
    display: none !important;
  }

  .main-info-content {
    background: transparent;
    box-shadow: none;
    border: none;
    padding: 0 2rem 0;
    border-radius: 0;
    text-align: center;

    .info-header {
      color: #86601f;
      font-size: 2.5rem;
      margin-bottom: 0.5rem;
      letter-spacing: 2px;
      font-family: 'Playfair Display', serif;
    }

    .info-description {
      color: #594a42;
      font-size: 1.7rem;
      margin: 0 auto;
      font-family: 'Inter', sans-serif;
    }
  }

  .steps-row-wrapper {
    padding-top: 2rem;
  }

  .step-card {
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(89, 74, 66, 0.1);

    &:hover {
      background: #ffffff;
      box-shadow: 0 20px 40px rgba(89, 74, 66, 0.15);
    }
  }

  @media (max-width: $tablet-portrait) {
    padding: 4rem 1rem;
    margin: 3rem 1rem;
    border-radius: 20px;

    .main-info-content {
      .info-header {
        font-size: 2.2rem;
      }

      .info-description {
        font-size: 1.4rem;
      }
    }
  }
}

.btn-plan-safari {
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  color: #ffffff;
  background-color: #bf8a2e;
  border: 1px solid #bf8a2e;
  padding: 1.4rem 2.6rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #86601f;
  }
}

/* Safari Planner Modal Styles */
.planner-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  z-index: 200000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  overflow-y: auto;
  min-height: 100vh;

  @media (max-width: 576px) {
    padding: 1rem;
  }
}

.planner-modal {
  position: relative;
  background: #fbf8f1;
  width: min(96vw, 1240px);
  height: min(92vh, 920px);
  max-height: 94vh;
  border-radius: 18px;
  padding: 2.2rem 2.6rem 1.6rem;
  box-shadow: 0 18px 50px -25px rgba(60, 45, 20, 0.35);
  border: 1px solid #ece3ce;
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 200001;

  @media (max-width: 768px) {
    width: 95vw;
    height: 94vh;
    padding: 1.8rem 1.4rem 1.4rem;
  }

  @media (max-width: 576px) {
    padding: 1.5rem 1.1rem 1.2rem;
    border-radius: 14px;
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Stepper Header */
.step-labels {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.step-label {
  font-family: 'Inter', sans-serif;
  font-size: 1.15rem;
  letter-spacing: 0.03em;
  font-weight: 600;
  color: #6b5f4f;

  &.active {
    color: #8a621f;
  }
}

.stepper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.step-dot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  flex-shrink: 0;
  border: 2px solid #e3d8bf;
  color: #6b5f4f;
  background: #fbf8f1;
  transition: all 0.2s ease;

  &.active {
    background: #b3812f;
    border-color: #b3812f;
    color: #ffffff;
  }

  &.done {
    background: #8a621f;
    border-color: #8a621f;
    color: #ffffff;
  }
}

.step-track {
  flex: 1;
  height: 2px;
  background: #e3d8bf;
  position: relative;
  overflow: hidden;
}

.step-track-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #8a621f;
  transition: width 0.3s ease;
}

/* Thumbnail row at top */
.image-row {
  display: flex;
  gap: 0.6rem;
  margin-bottom: 1rem;
  justify-content: center;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.planner-thumbnail {
  flex: 0 0 auto;
  width: 130px;
  height: 80px;
  min-width: 110px;
  object-fit: contain;
  background-color: #f7f4ed;
  border-radius: 10px;
  border: 2px solid transparent;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: block;

  &:hover {
    transform: scale(1.06);
    border-color: rgba(191, 138, 46, 0.4);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.12);
  }
}

/* Step content container */
.planner-step-content-container {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 1.4rem;
  background-color: #f6f0e4;
  border: 1px solid #e7ddca;
  border-radius: 14px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #eae2d1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbb387;
    border-radius: 4px;

    &:hover {
      background: #8a621f;
    }
  }
}

.step-pane {
  display: flex;
  flex-direction: column;
}

.planner-title {
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 2.1rem;
  line-height: 1.25;
  margin: 4px 0 6px;
  color: #2a2118;
}

.planner-subtitle {
  color: #6b5f4f;
  margin: 0 0 20px;
  font-size: 1.15rem;
  font-family: 'Inter', sans-serif;
}

.field-label {
  text-transform: uppercase;
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  font-weight: 700;
  color: #8a621f;
  margin-bottom: 8px;
  display: block;
  font-family: 'Inter', sans-serif;
}

.form-section {
  margin-bottom: 20px;
}

.form-section--inline {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  .field-label {
    margin-bottom: 0;
  }
}

.row {
  display: flex;
  gap: 16px;

  & > * {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 16px;
  }
}

.chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  border: 1px solid #e3d8bf;
  background: #ffffff;
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 1.1rem;
  color: #2a2118;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: border-color 0.15s ease, background 0.15s ease;
  font-family: 'Inter', sans-serif;

  &:hover {
    border-color: #b3812f;
  }

  &.selected {
    border-color: #b3812f;
    background: #fbf1de;
    color: #8a621f;
    font-weight: 600;
  }
}

.check {
  color: #8a621f;
  font-weight: 800;
}

.radio-group {
  display: flex;
  gap: 10px;
}

.radio-chip {
  border: 1px solid #e3d8bf;
  background: #ffffff;
  border-radius: 10px;
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 1.1rem;
  font-family: 'Inter', sans-serif;
  color: #2a2118;
  transition: all 0.15s ease;

  &.selected {
    border-color: #b3812f;
    background: #fbf1de;
    color: #8a621f;
    font-weight: 600;
  }
}

.radio-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #ece3ce;
  display: flex;
  align-items: center;
  justify-content: center;

  .radio-chip.selected & {
    border-color: #b3812f;
  }
}

.radio-dot-inner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #b3812f;
  display: none;

  .radio-chip.selected & {
    display: block;
  }
}

.guest-row {
  display: flex;
  gap: 12px;

  @media (max-width: 576px) {
    flex-direction: column;
  }
}

.counter-box {
  border: 1px solid #e3d8bf;
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  flex: 1;
}

.counter-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2a2118;
  font-family: 'Inter', sans-serif;
}

.counter-sub {
  font-size: 0.95rem;
  color: #6b5f4f;
  font-family: 'Inter', sans-serif;
}

.counter-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.round-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e3d8bf;
  background: #ffffff;
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
  color: #2a2118;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;

  &:hover {
    border-color: #b3812f;
    color: #8a621f;
  }
}

.counter-value {
  min-width: 18px;
  text-align: center;
  font-weight: 700;
  font-size: 1.1rem;
  color: #2a2118;
  font-family: 'Inter', sans-serif;
}

.budget-display {
  font-family: Georgia, serif;
  font-size: 2.6rem;
  font-weight: 700;
  color: #c96a00;
  text-align: center;
  margin: 2px 0 6px;

  span {
    color: #c96a00;
  }
}

.budget-unit {
  font-size: 1.2rem;
  font-family: 'Inter', sans-serif;
  color: #a04e00;
  margin-left: 6px;
  font-weight: 600;
}

.budget-slider-input {
  width: 100%;
  accent-color: #c96a00;
  height: 4px;
  cursor: pointer;
}

.range-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  color: #6b5f4f;
  margin-top: 4px;
  font-family: 'Inter', sans-serif;
}

.budget-summary-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
  }
}

.budget-tag {
  margin: 0;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  border: 1.5px solid #e07a00;
  background: #fff7ed;
  color: #9a3412;
  font-weight: 600;
  border-radius: 12px;
  padding: 9px 18px;
  font-size: 0.95rem;
  line-height: 1.45;
  text-align: center;
  font-family: 'Inter', sans-serif;
  box-shadow: 0 3px 12px rgba(224, 122, 0, 0.12);
  flex-shrink: 0;

  &--luxury {
    border-color: #c96a00;
    background: #fff4e5;
    color: #873600;
  }
}

.budget-total-highlight {
  font-weight: 800;
  font-size: 1.1rem;
  color: #ffffff;
  background: linear-gradient(135deg, #c96a00 0%, #a04e00 100%);
  padding: 3px 10px;
  border-radius: 6px;
  margin-left: 4px;
  box-shadow: 0 2px 8px rgba(160, 78, 0, 0.3);
}

.budget-exclusions-note {
  margin: 0;
  max-width: 480px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ecfdf5;
  border: 1.5px solid #10b981;
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 0.86rem;
  color: #064e3b;
  font-family: 'Inter', sans-serif;
  line-height: 1.4;
  text-align: left;
  box-shadow: 0 3px 12px rgba(16, 185, 129, 0.18);
}

.budget-exclusions-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 800;
  font-style: normal;
  flex-shrink: 0;
}

.budget-exclusions-text {
  flex: 1;

  strong {
    color: #047857;
    font-weight: 700;
  }
}

.dest-tooltip {
  z-index: 99999 !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  line-height: 1.35 !important;
  max-width: 240px !important;
  text-align: center !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  background-color: #241c12 !important;
  color: #f4ead6 !important;
  border: 1px solid rgba(212, 175, 55, 0.3) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25) !important;
  opacity: 0.98 !important;
}

.submit-bar {
  width: 100%;
  background: #8a621f;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 16px;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 8px;
  font-family: 'Inter', sans-serif;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #74501a;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.required-note {
  font-size: 0.95rem;
  color: #6b5f4f;
  margin-top: 0;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
}

.planner-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ece3ce;
  margin-top: 16px;
  padding-top: 16px;
  flex-shrink: 0;
}

.btn-primary {
  border-radius: 10px;
  padding: 12px 24px;
  font-size: 1.15rem;
  font-weight: 700;
  cursor: pointer;
  background: #8a621f;
  border: 1px solid #8a621f;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #74501a;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.btn-default {
  border-radius: 10px;
  padding: 12px 22px;
  font-size: 1.15rem;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #e3d8bf;
  background: #ffffff;
  color: #2a2118;
  font-family: 'Inter', sans-serif;

  &:hover {
    border-color: #b3812f;
    color: #8a621f;
  }
}

.btn-ghost {
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 1.15rem;
  font-weight: 600;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #e3d8bf;
  color: #6b5f4f;
  font-family: 'Inter', sans-serif;
  transition: all 0.2s ease;

  &:hover {
    border-color: #b3812f;
    color: #8a621f;
    background: #fbf8f1;
  }
}

.planner-header--left,
.planner-step-sub--left {
  text-align: left;
}

.step0-layout {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
}

.trip-preview {
  position: sticky;
  top: 0;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e4dccb;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);

  @media (max-width: 860px) {
    position: static;
  }
}

.trip-preview-media {
  position: relative;
  min-height: 320px;
  height: 100%;
  background-color: #6b5638;
  background-image: linear-gradient(135deg, #6b5638, #3c2c1a);
  background-size: cover;
  background-position: center;

  @media (max-width: 860px) {
    min-height: 200px;
  }
}

.trip-preview-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.6rem;
  padding: 2rem 1.8rem;
  background: linear-gradient(
    180deg,
    rgba(15, 12, 7, 0.42),
    rgba(15, 12, 7, 0.72)
  );
  color: #fdfaf4;
}

.trip-preview-days {
  align-self: flex-start;
  font-family: 'Inter', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: rgba(191, 138, 46, 0.9);
  color: #241a08;
  padding: 0.4rem 1rem;
  border-radius: 999px;
}

.trip-preview-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.1rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.trip-preview-route {
  font-family: 'Inter', sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #e8c374;
  line-height: 1.4;
}

.planner-input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e3d8bf;
  font-family: 'Inter', sans-serif;
  font-size: 1.1rem;
  color: #2a2118;
  background-color: #ffffff;
  transition: all 0.2s ease;
  box-sizing: border-box;

  &:focus {
    border-color: #b3812f;
    outline: none;
    box-shadow: 0 0 0 3px rgba(179, 129, 47, 0.15);
  }
}

.planner-textarea {
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e3d8bf;
  font-family: 'Inter', sans-serif;
  font-size: 1.1rem;
  color: #2a2118;
  background-color: #ffffff;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s ease;
  box-sizing: border-box;

  &:focus {
    border-color: #b3812f;
    outline: none;
    box-shadow: 0 0 0 3px rgba(179, 129, 47, 0.15);
  }
}

.destination-note {
  color: #6b5f4f;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  margin: 0.4rem 0 0;
}

.planner-tooltip {
  color: #d32f2f;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  margin-top: 0.45rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;

  &::before {
    content: '⚠️';
    font-size: 0.9rem;
  }
}

/* Validation Error Highlighting & Micro-animation */
.has-error {
  animation: shakeError 0.4s ease-in-out;
  padding: 8px 12px;
  border-radius: 10px;
  background-color: rgba(211, 47, 47, 0.05);
  border: 1px solid rgba(211, 47, 47, 0.35);

  .field-label {
    color: #d32f2f;
  }
}

.input-error {
  border-color: #d32f2f !important;
  background-color: #fff8f8 !important;
  box-shadow: 0 0 0 3px rgba(211, 47, 47, 0.15) !important;
  animation: shakeError 0.4s ease-in-out;
}

.radio-chip-error {
  border-color: #d32f2f !important;
  background-color: #fff8f8 !important;
  color: #d32f2f !important;
  animation: shakeError 0.4s ease-in-out;

  .radio-dot {
    border-color: #d32f2f !important;
  }
}

@keyframes shakeError {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-6px); }
  40%, 80% { transform: translateX(6px); }
}

.step-header-row {
  display: flex;
  align-items: center;
  gap: 4rem;
  margin-bottom: 1rem;
  flex-shrink: 0;
  padding-left: 1.4rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    margin-top: 0.8rem;
    margin-bottom: 1rem;
  }
}

.step-header-text {

  .planner-title {
    margin-bottom: 4px;
  }

  .planner-subtitle {
    margin-bottom: 0;
  }
}

.safari-type-tag {
  flex-shrink: 0;
  margin: 0;
  padding: 0.55rem 1.4rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #c96a00 0%, #a04e00 100%);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-size: 1.02rem;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 4px 14px rgba(201, 106, 0, 0.35);
  letter-spacing: 0.2px;
  white-space: nowrap;

  @media (max-width: 768px) {
    white-space: normal;
  }
}

.scroll-more-indicator {
  position: absolute;
  bottom: 74px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #c96a00 0%, #a04e00 100%);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 8px 18px;
  border-radius: 999px;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 22px rgba(201, 106, 0, 0.45);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  animation: bounceIndicator 2s infinite;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #b35d00 0%, #8a4200 100%);
    box-shadow: 0 8px 26px rgba(201, 106, 0, 0.6);
  }
}

@keyframes bounceIndicator {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-4px);
  }
  60% {
    transform: translateX(-50%) translateY(-2px);
  }
}
